import { makeStyles } from '@material-ui/core/styles';
import theme from "./theme";


const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        '& .Mui-error': {
            '& label': {
                color: theme.palette.error.main
            },
            '& .MuiInput-underline': {
                '&:after': {
                    transform: 'scaleX(1)',
                    borderBottomColor: theme.palette.error.main
                }
            }
        }
    },
    details: {
        display: 'block'
    },
    container: {
        textAlign: 'center',
        paddingTop: theme.spacing(7),
        paddingBottom: theme.spacing(2),
        '&:first-of-type': {
            paddingTop: theme.spacing(9),
        },
        '& .MuiContainer-root': {
            padding: 0,
        },
    },
    content: {
        flexGrow: 1,
        overflow: 'auto',
    },
    toolbar: {
        background: 'linear-gradient(45deg, ' + theme.palette.primary.main + ' 30%, ' + theme.palette.primary.light + ' 90%)',
        backgroundColor: theme.palette.primary.main,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        justifyContent: 'flex-end',
    },
    testToolbar: {
        backgroundColor: theme.palette.secondary.main,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        justifyContent: 'flex-end',
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(6),
    },
    blockSignature: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),

    },
    table: {
        whiteSpace: "nowrap",
        minWidth: 650,
        minHeight: 61,
        '& thead th': {
            minHeight: 61,
            height: 61,
        },
        '& tbody tr:nth-child(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    modal: {
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
        position: 'absolute',
        backgroundColor: theme.palette.secondary.main,
        color: '#FFFFFF',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 3, 4),
        outline: 'none',
        width: '90%',
        [theme.breakpoints.up('md')]: {
            width: '70%',
        },
        '& .MuiTypography-root.MuiTypography-h6': {
            marginBottom: theme.spacing(1),
        },
        '& .MuiPaginationItem-root': {
            color: '#FFFFFF',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: theme.palette.secondary.light,
        }
    },
    modalContent: {
        border: '1px solid #000',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightMedium,
    },
    capacities: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(1),
        },
    },
    logo: {
        flexGrow: 1,
        fontSize: 32,
    },
    logoWhite: {
        flexGrow: 1,
        fontSize: 32,
        '& path': {
            fill: '#FFFFFF',
        }
    },
    hidden: {
        display: 'none',
    },
    monospace: {
        fontFamily: "Monospace",
    },
    loadingBar: {
        position: 'relative',
        margin: '50px auto',
        width: '100px'
    },
    autoWidth: {
        width: 'auto',
        maxWidth: '100%',
        display: 'inline-flex',
    },
    marginAuto: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 'auto'
    },
    autoComplete: {
        '& .MuiTextField-root': {
            background: '#fff'
        },
        '& .MuiInputBase-input': {
            width: '100% !important'
        }
    },
    noPadding: {
        padding: 0,
    },
    paginationContainer: {
        margin: '1rem 0',
        '& .MuiPagination-ul': {
            justifyContent: 'flex-end'
        },
        '& .MuiTypography-root': {
            display: 'flex'
        },
    },
    formControl: {
        display: 'flex',
        alignItems: 'baseline',
        '&.MuiFormControl-marginNormal': {
            margin: 0,
        }
    },
    filter: {
        flexDirection: 'column',
    },
    filterBox: {
        border: '1px solid #dbdbdb',
        width: '100%',
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        position: 'relative',
        marginTop: theme.spacing(3),
    },
    filterSectionLabels: {
        border: '2px solid #FFFFFF',
        display: 'inline-block',
        paddingTop: 6,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        position: 'absolute',
        left: theme.spacing(1),
        top: -theme.spacing(2),
        fontWeight: 500,
        textTransform: 'uppercase',
    },
    chips: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
        fontWeight: 500,
        textTransform: 'uppercase',
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        '& .MuiChip-root': {
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
            paddingLeft: 4,
            paddingRight: 4,

            '&:first-of-type': {
                marginLeft: 0,
            },
            '& .MuiChip-label': {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
        },
    },
    circularProgress: {
        position: 'relative',
        margin: '50px auto',
        width: '100px',
    },
    deleteButton: {
        backgroundColor: `${theme.palette.error.main} !important`,
        borderColor: `${theme.palette.error.main} !important`,
        color: '#fff !important',
        '&:hover': {
            backgroundColor: `${theme.palette.error.dark} !important`,
            borderColor: theme.palette.error.dark,
        }
    },
    addButton: {
        backgroundColor: `${theme.palette.success.main} !important`,
        borderColor: `${theme.palette.success.main} !important`,
        color: '#fff !important',
        '&:hover': {
            backgroundColor: `${theme.palette.success.dark} !important`,
            borderColor: theme.palette.success.dark,
        },
        '&:disabled': {
            color: "rgba(0, 0, 0, 0.26)",
            boxShadow: "none !important",
            backgroundColor: "rgba(0, 0, 0, 0.12) !important",
        }
    },
    listSourceItems: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        padding: 0,
        '& li': {
            listStyleType: 'decimal',
            borderTop: '1px solid #dbdbdb',
            borderBottom: '1px solid #dbdbdb',
            marginTop: '-1px',
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            padding: theme.spacing(1),
            width: '49%',
        }
    },
    signatureNotification: {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
        '&:hover': {
            cursor: 'pointer'
        }
    },
    banner: {
        display: 'flex',
        alignItems: "center",
        justifyContent: "center",
    },
    optOuts: {
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: theme.spacing(2)
    }
}));

export default useStyles
